import styled from "styled-components";

export const PageWrapperStyled = styled.div`
  padding: 24px 32px;
`;

export const HeaderRowStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
`;

export const BackButtonStyled = styled.button`
  border: 1px solid ${(p) => p.theme?.colors?.border ?? "#D8DAE5"};
  background: #fff;
  border-radius: 6px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const SettingsCardStyled = styled.div`
  max-width: 560px;
  background: #fff;
  border: 1px solid ${(p) => p.theme?.colors?.border ?? "#D8DAE5"};
  border-radius: 8px;
  padding: 20px 24px;
  margin-bottom: 20px;
`;

export const SectionHeadingStyled = styled.div`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${(p) => p.theme?.colors?.primary ?? "#008080"};
  margin: 0 0 10px;
`;

export const FieldRowStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid ${(p) => p.theme?.colors?.borderLight ?? "#E5E7EB"};
  &:last-of-type { border-bottom: none; }
  .label { font-size: 13px; font-weight: 600; }
  .desc { font-size: 11.5px; color: ${(p) => p.theme?.colors?.textSecondary ?? "#5A6A7A"}; margin-top: 2px; }
`;
